import React from 'react'
import { Link } from 'react-router-dom'
import { Badge } from 'reactstrap'

export const parameterColumns = (layout, role) => [
	{
		name: 'ID',
		selector: (row) => row.id || '',
		sortable: true,
		width: '7%',
		cell: (row) => (
			<Link to="#" className="text-decoration-none">
				{row.id}
			</Link>
		)
	},
	{
		name: 'Type',
		selector: (row) => row.type || '',
		sortable: true,
		width: '15%'
	},
	{
		name: 'Parameter',
		selector: (row) => row.pname || '',
		sortable: true,
		width: '20%'
	},
	{
		name: 'Order',
		selector: (row) => row.order || 0,
		sortable: true,
		width: '7%'
	},
	{
		name: 'Status',
		selector: (row) => row.isActive,
		sortable: true,
		width: '10%',
		cell: (row) => <Badge color={row.isActive ? 'success' : 'danger'}>{row.isActive ? 'Active' : 'Inactive'}</Badge>
	},
	{
		name: 'Actions',
		selector: (row) => row.id,
		sortable: false,
		width: '35%',
		cell: (row) => (
			<div className="d-flex gap-2">
				<Link to={`${process.env.PUBLIC_URL}/${role}/parameters/edit/${row.id}/${layout}`} className="btn btn-success btn-sm">
					<i className="fa fa-edit me-1"></i>
				</Link>
				<button className="btn btn-danger btn-sm" onClick={() => row.onDelete && row.onDelete(row.id)}>
					 <i className="fa fa-trash"></i>
				</button>
			</div>
		)
	}
]
